<template>
  <div class="personal-ident-data summary-list">
    <div class="summary-row">
      <div class="label">
        <slot name="lblPassword">Passwort</slot>
      </div>
      <div class="value"><slot name="txtPassword">*********</slot></div>
    </div>
    <div class="summary-row">
      <div class="label">
        <slot name="lblNationality">Staatsangehörigkeit</slot>
      </div>
      <div class="value">{{ identificationFull.nationality.name }}</div>
    </div>
    <div class="summary-row">
      <div class="label">
        <slot name="lblIdentCard">Ausweistyp</slot>
      </div>
      <div class="value">{{ identificationFull.identCard.name }}</div>
    </div>
    <div class="summary-row">
      <div class="label">
        <slot name="lblIdentType"><abbr title="Identifikation">Ident</abbr>-Verfahren</slot>
      </div>
      <div class="value">
        <slot :name="`txtIdentType${identificationFull.identType}`">{{ identificationFull.identType }}</slot>
      </div>
    </div>
    <SimTypeSummary>
      <template v-for="slot in possibleChildSlotsFor('SimTypeSummary')" v-slot:[`${slot.child}`]>
        <slot :name="`${slot.parent}`"></slot>
      </template>
    </SimTypeSummary>
  </div>
</template>
<script>
import { mapGetters } from 'vuex'
import slotProxy from '@/mixins/slotProxy'
import SimTypeSummary from '@/components-v2/flows/LIDL/Activation/Sim/ShowSimType.vue'

export default {
  name: 'PersonalDataIdentSummary',
  components: { SimTypeSummary },
  mixins: [slotProxy()],
  computed: {
    ...mapGetters('activation/personalData', ['identificationFull'])
  }
}
</script>
